import { userRequest } from '../lib/userRequest';

export const getAppConfig = async (apiSecret) => {
  return userRequest('get', '/config', {
    headers: {
      'Authorization': `Bearer ${apiSecret}`
    }
  }, false, {}, false);
};